import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { DivIcon } from 'leaflet';
import { Marker as LMarker, Popup } from 'react-leaflet';
import { colors, colorsPOI } from './styles';
import { svgIcons } from './icons';
var iconSize = {
  undefined: 'small-',
  start: '',
  end: '',
  pickup: 'medium-',
  delivery: 'medium-',
  place: '',
  parking: 'small-',
  superbig: 'superbig-'
};
var iconPxSize = {
  undefined: 15,
  start: 25,
  end: 25,
  pickup: 18,
  delivery: 18,
  place: 25,
  parking: 15
};

var styles = function styles(theme) {
  var style = {
    marker: {
      boxSizing: 'border-box',
      height: '25px',
      width: '25px',
      border: '2px solid #717679',
      borderRadius: '50%',
      boxShadow: '0 0 0 2px white',
      backgroundColor: '#DFE6EF',
      fontWeight: 'bold',
      fontSize: '10px',
      textAlign: 'center'
    }
  };
  style['marker-selected'] = _extends({}, style.marker, {
    backgroundColor: theme.palette.primary.main
  });
  colors.forEach(function (color, index) {
    style["marker".concat(index)] = _extends({}, style.marker, {
      backgroundColor: 'white',
      border: "2px solid ".concat(color)
    });
    style["marker".concat(index, "-selected")] = _extends({}, style.marker, {
      backgroundColor: theme.palette.primary.main,
      border: "2px solid ".concat(color),
      zIndex: '10000 !important'
    });
  }); // Add small & medium versions

  for (var key in style) {
    style["small-".concat(key)] = _extends({}, style[key], {
      height: '15px',
      width: '15px'
    });
    style["medium-".concat(key)] = _extends({}, style[key], {
      height: '18px',
      width: '18px'
    });
    style["superbig-".concat(key)] = _extends({}, style[key], {
      height: '50px',
      width: '50px'
    });
  }

  style['select-area'] = {
    height: '33px',
    width: '33px',
    borderRadius: '50%'
  };
  style['small-select-area'] = {
    height: '23px',
    width: '23px',
    borderRadius: '50%'
  };
  style['medium-select-area'] = {
    height: '26px',
    width: '26px',
    borderRadius: '50%'
  };
  style['superbig-select-area'] = {
    height: '58px',
    width: '58px',
    borderRadius: '50%'
  };
  return style;
};

var Marker =
/*#__PURE__*/
function (_Component) {
  _inherits(Marker, _Component);

  function Marker() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Marker);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Marker)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      bounds: undefined
    }, _this.componentDidMount = function () {
      _this.setBounds();
    }, _this.componentWillReceiveProps = function (props) {
      _this.setBounds(props);
    }, _this.setBounds = function (props) {
      var _ref = props || _this.props,
          lat = _ref.lat,
          lng = _ref.lng,
          onBounds = _ref.onBounds;

      if (lat !== undefined && lng !== undefined) {
        var minLat = lat,
            minLng = lng,
            maxLat = lat,
            maxLng = lng;

        _this.setState({
          bounds: [[minLat, minLng], [maxLat, maxLng]]
        });

        if (onBounds) {
          onBounds([[minLat, minLng], [maxLat, maxLng]]);
        }
      }
    }, _this.markerIcon = function (color) {
      var _this$props = _this.props,
          classes = _this$props.classes,
          kind = _this$props.kind,
          selected = _this$props.selected;
      var iconColor;

      if (selected) {
        iconColor = '#FFFFFF';
      } else if (color === undefined) {
        iconColor = '#717679';
      } else {
        iconColor = colors[color];
      }

      var style = "padding:0px;width:100%;height:100%;fill:".concat(iconColor);
      var icon = new DivIcon({
        html: kind ? "<svg viewBox=\"0 0 24 24\" style=\"".concat(style, "\"><path d=\"").concat(svgIcons[kind], "\"></path></svg>") : '<span/>',
        className: classes[iconSize[kind] + (color !== undefined ? "marker".concat(color % colors.length) : 'marker') + (selected ? '-selected' : '')],
        iconSize: null,
        iconAnchor: [iconPxSize[kind] / 2, iconPxSize[kind] / 2]
      });
      return icon;
    }, _this.selectArea = function () {
      var _this$props2 = _this.props,
          classes = _this$props2.classes,
          kind = _this$props2.kind,
          selected = _this$props2.selected,
          visited = _this$props2.visited;
      var iconColor = colors[0];

      if (kind === 'place') {
        if (selected) {
          iconColor = colorsPOI.selected;
        } else {
          if (visited) {
            iconColor = colorsPOI.visited;
          } else {
            iconColor = colorsPOI.noSelected;
          }
        }
      } else if (kind === 'parking') {
        iconColor = colorsPOI.parking;
      }

      var style = "padding:0px;width:100%;height:100%;fill:".concat(iconColor);
      var iconHtml = '<span/>';

      if (kind) {
        iconHtml = "<svg viewBox=\"0 0 24 24\" style=\"".concat(style, "\">\n          ").concat(kind === 'parking' && '<path fill="#FFFFFF" d="M21.1,0H2.9C1.4,0,0.1,1.3,0.1,2.8V21c0,1.5,1.2,2.8,2.8,2.8h18.2c1.5,0,2.8-1.2,2.8-2.8V2.8   C23.9,1.3,22.6,0,21.1,0z"/>', "\n            ").concat(kind === 'place' && "<path fill=\"".concat(selected ? '#FFFFFF' : '#57637C', "\" d=\"m11.9 1.5c-4.5 0-8.1 3.3-8.1 7.8s8.1 13.7 8.1 13.7 8.2-9.1 8.2-13.6-3.7-7.9-8.2-7.9z\"/>"), "\n        <path d=\"").concat(svgIcons[kind], "\"></path>\n        \n        ").concat(kind === 'parking' && '<path fill="#FFFFFF" d="m13.5 4.1h-6.9v16h2v-5.7h4.9c2.7 0 4.9-2.3 4.9-5.1 0-2.9-2.2-5.2-4.9-5.2zm0 8.2h-5v-6.2h4.9c1.6 0 3 1.4 3 3.1s-1.3 3.1-2.9 3.1z"/>', "\n        </svg>");
      }

      var anchor = [iconPxSize[kind] / 2 + 4, iconPxSize[kind] / 2 + 4];

      if (kind === 'place') {
        if (selected) {
          anchor = [50 / 2 + 4, 50 + 4];
        } else {
          anchor = [iconPxSize[kind] / 2 + 4, iconPxSize[kind] + 4];
        }
      }

      var icon = new DivIcon({
        html: iconHtml,
        className: selected && kind === 'place' ? classes[iconSize.superbig + 'select-area'] : classes[iconSize[kind] + 'select-area'],
        iconSize: null,
        iconAnchor: anchor
      });
      return icon;
    }, _this.handleOnClick = function () {
      var onClick = _this.props.onClick;

      if (onClick) {
        onClick();
      }
    }, _temp));
  }

  _createClass(Marker, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          lat = _this$props3.lat,
          lng = _this$props3.lng,
          keyMarker = _this$props3.keyMarker,
          color = _this$props3.color,
          label = _this$props3.label,
          kind = _this$props3.kind,
          zoomLevel = _this$props3.zoomLevel,
          visited = _this$props3.visited;

      if ((kind === 'start' || kind === 'end' || kind === 'parking') && zoomLevel < 12) {
        return null;
      }

      if (kind === 'place' || kind === 'parking') {
        return React.createElement(LMarker, {
          key: keyMarker,
          position: [lat, lng],
          icon: this.selectArea(),
          onClick: this.handleOnClick,
          visited: visited
        }, label && React.createElement(Popup, null, label));
      }

      return React.createElement(React.Fragment, null, React.createElement(LMarker, {
        key: keyMarker,
        position: [lat, lng],
        icon: this.selectArea(),
        onClick: this.handleOnClick // opacity={0}

      }), React.createElement(LMarker, {
        key: keyMarker,
        position: [lat, lng],
        icon: this.markerIcon(color),
        onClick: this.handleOnClick
      }, label && React.createElement(Popup, null, label)));
    }
  }]);

  return Marker;
}(Component);

Marker.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  keyMarker: PropTypes.any,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.oneOfType([PropTypes.string, Element]),
  kind: PropTypes.oneOf(['start', 'end', 'pickup', 'delivery', 'place', 'parking']),
  selected: PropTypes.bool,
  visited: PropTypes.bool
};
Marker.defaultProps = {
  selected: false,
  visited: undefined
};
export default withStyles(styles)(Marker);